export default {
    title: state => {
        return state.title;
    },
    titleEn: state => {
        return state.titleEn;
    },
    key: state => {
        return state.key;
    },
    permissionRooms: state => {
        return state.permissionRooms;
    },
    permissionRoom: state => {
        return state.permissionRoom;
    },
    permissionRoomsToEdit: state => {
        return state.permissionRoomsToEdit;
    },
    total: state => {
        return state.total;
    }
}
